import { Button } from '@kalos/ui';
import CircularProgress from '@mui/material/CircularProgress';
import { type FC, useCallback, useEffect } from 'react';

import { downloadJsonAsCsv } from './downloadJsonAsCsv';
export type Status = 'idle' | 'loading' | 'loaded';
export interface Column {
  label: string;
  value: string;
}

interface Props {
  filename: string | (() => string);
  json: Array<unknown>;
  onExport?: () => void;
  onExported?: () => void;
  columns?: Column[]; // Modify this line
  status?: Status;
  children?: React.ReactNode;
  disabled?: boolean;
  /** Defaults to the filled button; a toolbar beside other outline buttons passes 'outline'. */
  variant?: 'default' | 'outline';
  className?: string;
}

export const ExportJSON: FC<Props> = ({
  filename,
  json,
  columns,
  onExport,
  onExported,
  status,
  children,
  disabled,
  variant,
  className,
}) => {
  const handleExport = useCallback(
    () => downloadJsonAsCsv(filename, json, columns),
    [json, filename, columns],
  );

  useEffect(() => {
    if (status === 'loaded') {
      handleExport();
      if (onExported) {
        onExported();
      }
    }
  }, [status, handleExport, onExported]);

  return (
    <Button
      size="sm"
      variant={variant}
      className={className}
      onClick={onExport || handleExport}
      disabled={status === 'loading' || disabled}
    >
      {status === 'loading' && (
        <CircularProgress style={{ color: '#FFF', marginRight: 8 }} size={16} />
      )}
      {children || 'Export to Excel'}
    </Button>
  );
};
